import React from "react";
import { Button, Modal } from "@toddle-edu/ds-web";

import { Step1, Step2 } from "./components";
import { STEPS } from "./modules/Utils";
import { useI18n } from "Hooks";
import { ChevronLeftOutlined } from "@toddle-edu/ds-icons";
import { useManageWorkflowModal } from "./modules/ManageWorkflowModalContext";

const modalHeaderStyles = {
  alignItems: "center",
  gap: "8px",
};

const ManageWorkflowsModal = props => {
  const { onClose, jobFeedVariables } = props;
  const {
    isModalOpen,
    currentStep,
    setCurrentStep,
    headerProps,
    activeWorkflowId,
    setHeaderProps,
    setActiveWorkflowId,
  } = useManageWorkflowModal();

  const { t } = useI18n(["workflows", "common"]);

  const handleStepChange = step => {
    setCurrentStep(step);
  };

  const onClickBackButton = () => {
    handleStepChange("STEP_1");
  };

  return (
    <Modal
      height="490px"
      width="800px"
      dsVersion="2.0"
      hasOverlay={true}
      onClose={onClose}
      isOpen={isModalOpen}
    >
      <Modal.Header
        style={modalHeaderStyles}
        prefix={
          currentStep === STEPS.STEP_2 ? (
            <Button
              dsVersion="2.0"
              size="medium"
              icon={<ChevronLeftOutlined />}
              variant="neutral"
              type="plain"
              onClick={onClickBackButton}
            />
          ) : null
        }
        title={headerProps?.[currentStep]?.title}
        subtitle={headerProps?.[currentStep]?.subtitle}
      />

      <Modal.Body isScrollable>
        {currentStep === STEPS.STEP_1 ? (
          <Step1
            handleStepChange={handleStepChange}
            currentStep={currentStep}
            jobFeedVariables={jobFeedVariables}
            setHeaderProps={setHeaderProps}
            setActiveWorkflowId={setActiveWorkflowId}
            t={t}
          />
        ) : (
          <Step2 subTaskId={activeWorkflowId} t={t} />
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ManageWorkflowsModal;
